import {
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  FormLabel,
  Radio,
  FormGroup,
  RadioGroup,
  FormControl,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  TableFooter,
} from "@mui/material";
import React from "react";

const Comp10PDF = ({
    formData,
    items,
    checked
}) => {

    const isNoApply =
        formData?.exhibitor_status === "申請しない" &&
        formData?.host_status === "申請しない" &&
        formData?.corporate_status === "申請しない";

    const getMoveRadioValue = (value, defaultTime) => {
    if (value === defaultTime) return 'default';
    if (value?.startsWith('それ以外')) return 'other';
    return '';
    };

  return (
    <Container sx={{ mt: 5, borderRadius: 2, position: 'relative', py: 4, width:'140%' }}>
    <Box>
        <Typography variant="h6">SDGs 子ども・ユースフェア出展者　マイページ情報</Typography>
        {formData ? (
        <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography variant="body1">小間番号: {formData?.booth_number}</Typography>
            <Typography variant="body1">出展者名: {formData?.company_name}</Typography>
            <Typography variant="body1">部署: {formData?.department}</Typography>
            <Typography variant="body1">担当者名: {formData?.user_name}</Typography>
            <Typography variant="body1">郵便番号: {formData?.zip_code}</Typography>
            <Typography variant="body1">住所: {formData?.address}</Typography>
            <Typography variant="body1">電話番号: {formData?.phone_number}</Typography>
            <Typography variant="body1">メールアドレス: {formData?.email}</Typography>
        </Box>
        ) : (
        <Typography variant="body2">読み込み中...</Typography>
        )}
    </Box>
    <Box>
        <Typography variant="h6">PC・ソフトレンタル申込</Typography>
        <FormControlLabel
            control={<Checkbox checked={isNoApply} readOnly />}
            label="申請しない"
        />
        {!isNoApply && (
        <>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_ex}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>氏名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_10_name}</Box>
                <Box>部署</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_10_department}</Box>
                <Box>会社電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_10_phone}</Box>
                <Box>携帯電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_10_tel}</Box>
            </Box>
            <Typography variant="h6" gutterBottom>
            請求先情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_in}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>請求先会社名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_company_name}</Box>
                <Box>請求担当者名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_user_name}</Box>
                <Box>請求先メールアドレス</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_email}</Box>
                <Box>郵便番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_zip}</Box>
                <Box>請求先住所</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_address}</Box>
                <Box>電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_tel}</Box>
                <Box>FAX番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_fax}</Box>
            </Box>
        </Box>   
        <Box>
            {/* <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>インターネット接続</Typography>
            <FormControl component="fieldset">
            <RadioGroup
                row
                value={formData?.internet}
            >
                <FormControlLabel value="true" control={<Radio />} label="希望する" />
                <FormControlLabel value="false" control={<Radio />} label="希望しない" />
            </RadioGroup>

            {formData?.internet && (
                <Box sx={{ mt: 1 }}>
                <Box sx={{display: 'flex'}}>
                    <img src="/internet_qr.png" alt="QRコード" style={{ width: 150 }} />
                    <Typography>＜申込みサイトURL＞ https://entry.mice-net.jp/ex/593/reg</Typography>
                </Box>
                <Typography variant="body2" color="textSecondary">
                    URLもしくはQRコードからお申し込みください
                </Typography>
                </Box>
            )}
            </FormControl> */}
            <Box>
                <FormGroup row>
                    <FormControlLabel
                    control={<Checkbox name="yespc" checked={checked.pc} />}
                    label="PC・ソフトレンタルを希望する"
                    />
                    <FormControlLabel
                    control={<Checkbox name="nopc" checked={!checked.pc} />}
                    label="PC・ソフトレンタルを希望しない"
                    />
                </FormGroup>
            </Box>
            {checked.pc && (
            <>
            <Table size="small">
            <TableHead>
                <TableRow>
                <TableCell>品番</TableCell>
                <TableCell>品名</TableCell>
                <TableCell sx={{width: '100px'}}>単価(税込)</TableCell>
                <TableCell>数量</TableCell>
                <TableCell sx={{width: '100px'}}>合計</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            {items.map((item) => {
                const detail = formData?.details.find(d => d.item_id === item.item_id);
                const number = detail?.number || 0;

                if (number <= 0) return null; // ← ここ追加

                const hasPrice = item.unit_price != null;
                const unitTotal = hasPrice ? item.unit_price * number : null;
                const showNotice = ["A","B","C"].includes(item.item_id);

                return (
                <React.Fragment key={item.item_id}>
                    <TableRow>
                    <TableCell>
                        <Typography sx={{ fontFamily: "monospace" }}>
                        {item.item_id}
                        </Typography>
                    </TableCell>

                    <TableCell>
                        {item.item_name}
                        {showNotice && (
                        <Typography color="error" variant="body2">
                            ※インストール費込み<br />
                            ※MS Officeは「2024/2021/2019」のうち一つをインストールします。お申し込みの際は、バージョンの指定を備考欄に記入をしてください。
                        </Typography>
                        )}
                    </TableCell>

                    <TableCell>
                        {hasPrice ? `¥${item.unit_price.toLocaleString()}` : "要問合せ"}
                    </TableCell>

                    <TableCell>{number}</TableCell>

                    <TableCell>
                        {hasPrice ? `¥${unitTotal.toLocaleString()}` : "要問合せ"}
                    </TableCell>
                    </TableRow>
                </React.Fragment>
                );
            })}
            </TableBody>
            <TableFooter>
            <TableRow>
                <TableCell colSpan={4} align="right">
                <Typography variant="subtitle1">総合計金額:</Typography>
                </TableCell>
                <TableCell>
                <Typography variant="subtitle1">
                    ¥{(formData?.total_price ?? 0).toLocaleString()}
                </Typography>
                </TableCell>
            </TableRow>
            </TableFooter>
            </Table>
            {/* <Typography color="error" variant="body2" sx={{mt: 1 , mb: 1}}>
                上記レンタル料金は、会期中の特別料金（運送費込金額）です。開梱、設置、梱包作業は含みません。<br />
                オプションとしてブース内ネットワーク配線、設定、機器開梱作業、解体撤去等を有償にて承ります。別途ご相談ください。<br />
                上記以外にも、各社パソコン本体、周辺機器、ネットワーク機器など、多数取り揃えています。
            </Typography> */}
            {/* <Typography color="error" sx={{border: '1px solid #000', padding: 2}}>
                ※名刺交換用iPhoneパッケージプランをお申し込みの方は、こちらからお申し込み下さい。<br />
                お問い合わせは、(株)中部経済新聞社にご連絡ください。
            </Typography> */}
            {/* <Typography variant="h6" gutterBottom>商品搬入</Typography>
            <FormControl component="fieldset">
            <RadioGroup
                row
                value={formData?.move_in}
            >
                <FormControlLabel value="true" control={<Radio />} label="11月4日" />
                <FormControlLabel value="false" control={<Radio />} label="事前納品" />
            </RadioGroup>

            {formData?.move_in ? (
                // 11/4を選んだ場合の詳細選択
                <Box sx={{ mt: 1 }}>
                <RadioGroup
                value={getMoveRadioValue(formData?.move_in_detail, '10:00~12:00')}
                >
                    <FormControlLabel value="default" control={<Radio />} label="10:00～12:00" />
                    <FormControlLabel value="other" control={<Radio />} label="それ以外" />
                </RadioGroup>
                {formData?.move_in_detail?.startsWith?.('それ以外') && (
                <TextField
                fullWidth
                label="搬入希望時間"
                value={formData?.move_in_detail?.replace('それ以外:', '')}
                InputLabelProps={{ shrink: true }}
                />
                )}
                </Box>
            ) : (
                // 事前納品を選んだ場合の詳細
                <Box sx={{ mt: 1 }}>
                <TextField
                fullWidth
                label="希望日時"
                sx={{ mb: 1 }}
                value={formData?.move_in_detail?.split(',納品先情報:')[0]?.replace('希望日時:', '') || ''}
                />

                <TextField
                fullWidth
                label="納品先情報"
                value={formData?.move_in_detail?.split(',納品先情報:')[1] || ''}
                />
                <Typography color="error">会社名・住所・担当者名等をご入力ください。</Typography>
                </Box>
            )}
            </FormControl>
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>商品搬出</Typography>
            <FormControl component="fieldset">
            <RadioGroup
                row
                value={formData?.move_out}
            >
                <FormControlLabel value="true" control={<Radio />} label="11月7日" />
                <FormControlLabel value="false" control={<Radio />} label="事前回収" />
            </RadioGroup>

            {formData?.move_out ? (
                <Box sx={{ mt: 1 }}>
                <RadioGroup
                value={getMoveRadioValue(formData?.move_out_detail, '17:00~19:00')}
                >
                    <FormControlLabel value="default" control={<Radio />} label="17:00～19:00" />
                    <FormControlLabel value="other" control={<Radio />} label="それ以外" />
                </RadioGroup>
                {formData?.move_out_detail.startsWith('それ以外') && (
                    <TextField
                        fullWidth
                        label="搬出希望時間"
                        value={formData?.move_out_detail?.replace('それ以外:', '')}
                        InputLabelProps={{ shrink: true }}
                    />
                )}
                </Box>
            ) : (
                <Box sx={{ mt: 1 }}>
                <TextField
                    fullWidth
                    label="希望日時"
                    sx={{ mb: 1 }}
                    value={formData?.move_out_detail?.split(',回収先情報:')[0]?.replace('希望日時:', '') || ''}
                />
                <TextField
                    fullWidth
                    label="回収先情報"
                    value={formData?.move_out_detail?.split(',回収先情報:')[1] || ''}
                />
                <Typography color="error">会社名・住所・担当者名等をご入力ください。</Typography>
                </Box>
            )}
            </FormControl> */}
            </>
            )}
            <Typography variant="h6">備考欄</Typography>
            <Typography color="error">※PC・ソフトレンタル申込について補足事項等がある場合はコチラにご入力ください。</Typography>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {formData?.alfa_text}
                        </Typography>
        </Box>
        </>
        )}
    </Box>
    </Container>
  );
};

export default Comp10PDF;
